module.exports = __webpack_public_path__ + "static/media/web-bg.da95ffdd.mp4";